import React from 'react'

interface StringRendererProps {
  value?: string
  onClick?: () => void
}

const StringRenderer: React.FC<StringRendererProps> & { RENDERER_TYPE: string } = props => {
  const { value, onClick } = props

  const handleClick = (_e: React.MouseEvent<HTMLSpanElement>) => {
    if (onClick) {
      onClick()
    }
  }

  return (
    <span className="content-renderer content-renderer--string string-renderer" title={value} onClick={handleClick}>
      {value}
    </span>
  )
}

StringRenderer.RENDERER_TYPE = 'string'

export default StringRenderer
